// extracted by mini-css-extract-plugin
module.exports = {"playingcard":"card_playingcard__10vq3","cardtypographytitle":"card_cardtypographytitle__3OkhR","cardtypographybody":"card_cardtypographybody__2Hj2p"};